<template>
  <div class="custom-select room-list-select" @blur="open = false">
    <div class="selected" :class="{ open: open }" @click="open = !open">
      <div class="session--title">
        <span v-if="selected.ROOM_ICON && selected.ROOM_IMAGE === 'icon'" class="room-list-select__room-image icon"
          ><i :class="selected.ROOM_ICON" aria-hidden="true"></i
        ></span>
        <span v-if="selected.ROOM_LOGO && selected.ROOM_IMAGE === 'logo'" class="room-list-select__room-image logo">
          <img :src="selected.ROOM_LOGO" aria-hidden="true" />
        </span>
        <div>{{ selected.TITLE }}</div>
      </div>
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <div
        v-for="(room, i) of rooms"
        :key="room.uuid"
        class="session"
        :style="roomItemColor[i]"
        @click="selectOption(room)"
      >
        <div class="session--title">
          <span v-if="room.ROOM_ICON && room.ROOM_IMAGE === 'icon'" class="room-list-select__room-image icon"
            ><i :class="room.ROOM_ICON" aria-hidden="true"></i
          ></span>
          <span v-if="room.ROOM_LOGO && room.ROOM_IMAGE === 'logo'" class="room-list-select__room-image logo">
            <img :src="selected.ROOM_LOGO" aria-hidden="true" />
          </span>
          <div>{{ room.TITLE }} <small v-if="room.uuid === selected.uuid">(current)</small></div>
        </div>
        <div class="session--description">
          <p v-if="room.DESCRIPTION" v-html="room.DESCRIPTION" class="description"></p>
          <div>
            <i class="fa fa-users" aria-hidden="true"></i>
            <small>{{ getRoomUsersLength(room) }} Attendees</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ROUTES } from "@/helpers/constants";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "RoomListSelect",
  props: {
    rooms: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selected: null,
      open: false
    };
  },
  computed: {
    ...mapGetters({
      multipleRooms: "room/multipleRooms",
      users: "room/roomState"
    }),
    roomItemColor() {
      return this.rooms.map(room => {
        if (room.ROOM_COLOUR_TYPE === "custom" && room.ROOM_COLOUR) {
          return {
            "--room-color": room.ROOM_COLOUR,
            order: this.order(room) || 0
          };
        }
        return { "--room-color": "var(--color-primary)", order: this.order(room) || 0 };
      });
    }
  },
  methods: {
    ...mapActions({
      changeRoom: "room/changeRoom",
      getRooms: "room/getRooms"
    }),
    async selectOption(room) {
      if (this.selected.SLUG === room.SLUG) return;
      this.selected = room;
      this.open = false;
      this.$router.push({ name: ROUTES.DIGITAL_EVENT_ROOM, params: { roomSlug: this.selected.SLUG } });
      await this.changeRoom({ slug: this.selected.SLUG, enterRoomUUID: this.selected.uuid });
    },
    order(room) {
      return this.multipleRooms.find(r => r.uuid === room.uuid)?.room_order;
    },
    getRoomUsersLength(room) {
      return this.users.filter(user => user.roomUUID === room.uuid).length;
    }
  },
  async created() {
    this.selected = this.rooms.find(room => room.SLUG === this.$route.params.roomSlug);
    await this.getRooms(this.$store.state.event.context.uuid);
  }
};
</script>

<style scoped lang="less">
.custom-select .items {
  .session {
    background-color: var(--room-color);
    margin: 3px;
    transition: all 0.3s ease;

    &:hover {
      background-color: var(--room-color);
      opacity: 0.7;
    }
  }
}
</style>
